import { EditCampaignSessionValue } from '../typings/campaignsEdit';

import { Session } from './Session/Session';
import { StorageKeyType } from './Storage/Storage';

export class CampaignsIdsForCampaignsEditHelpers {
    public static getCampaignsIds(login: string): EditCampaignSessionValue {
        const { editCampaigns } = Session.getValueFromCurrentSession(login);

        if (!editCampaigns) {
            return {
                campaignsIds: []
            };
        }

        return editCampaigns;
    }

    public static setCampaignsIds(login: string, campaignIds: string[]): void {
        const currentSession = Session.getValueFromCurrentSession(login);

        Session.setValueToCurrentSession(login, {
            ...currentSession,
            [StorageKeyType.editCampaigns]: {
                campaignsIds: campaignIds
            }
        });
    }
}
